import {
  loadCss, loadJS, UUID, debounce,
} from '../../modules/utils';
/* eslint-disable no-underscore-dangle */
import './index.less';

const VIEWER_CSS_URL = 'https://s.vipkidstatic.com/fe-static/hobbit/asset/lib/viewer/viewer.min.css';
const VIEWER_JS_URL = 'https://s.vipkidstatic.com/fe-static/hobbit/asset/lib/viewer/viewer.min.js?v=1';
let originMarginLeft = '';
let originMarginTop = '';
/**
 * 媒体查看组件
 */
const MediaView = class {
  constructor() {
    this.elId = 'hobbit_media';
    this.viewerSdk = null;
    this.viewer = null;
    // debounce 包装 viewer zoomTo 事件
    this.zoomTo = debounce((ratio) => {
      this.viewer.zoomTo(ratio);
      document.querySelector('.viewer-move').style.marginLeft = originMarginLeft;
      document.querySelector('.viewer-move').style.marginTop = originMarginTop;
    }, 120);
    // debounce 包装 viewer moveTo 事件
    this.moveTo = debounce((x, y) => {
      this.viewer.moveTo(x, y);
    }, 100);
  }

  el() {
    let el = document.getElementById(this.elId);
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('id', this.elId);
      el.className = 'hobbit_media';
      const closeEl = document.createElement('div');
      closeEl.className = 'hobbit_media_close';
      closeEl.innerHTML = '×';
      const clickEventFn = (e) => {
        if (e.target.id === 'hobbit_media' || e.target.className === 'hobbit_media_close') {
          this.hide();
        }
      };
      el.clickEventFn = clickEventFn.bind(this);
      el.addEventListener('click', el.clickEventFn);
      el.appendChild(closeEl);
      document.body.appendChild(el);
    }
    return el;
  }

  initChild(type, url, id) {
    const el = this.el();
    if (el.children[1]) {
      el.children[1].remove();
    }
    const _type = type.toLocaleLowerCase();
    const child = document.createElement(_type);
    child.src = url;
    child.className = 'im-media';
    child.id = id;
    if (_type === 'video') {
      child.autoplay = 'autoplay';
      child.controls = 'controls';
    }
    el.appendChild(child);
  }

  async show(type = '', url = '') {
    if (!type || !url) return;
    const el = this.el();
    const id = UUID();
    this.initChild(type, url, id);
    if (type.toLocaleLowerCase() === 'img') {
      // el.className = 'hobbit_media opacity';
      if (!this.viewerSdk) {
        // 加载远程 css
        await loadCss(VIEWER_CSS_URL);
        await loadJS(VIEWER_JS_URL);
        this.viewerSdk = window.Viewer || null;
      }
      if (window.Viewer) {
        if (this.viewer) this.viewer.destroy();
        const mediaViewer = this;
        const img = document.querySelector('.im-media');
        if (img) {
          let initRatio = 0;
          this.viewer = new window.Viewer(document.getElementById(id), {
            inline: false,
            navbar: false,
            toolbar: false,
            keyboard: true,
            zoomed(e) {
              // 记录初始比例
              if (e.detail.oldRatio && initRatio === 0) {
                initRatio = e.detail.oldRatio;
              }
              if (e.detail.ratio < initRatio) {
                mediaViewer.zoomTo(initRatio);
              }
            },
            viewed() {
              // 记录原始边距
              const showEl = document.querySelector('.viewer-move');
              originMarginLeft = showEl.style.marginLeft;
              originMarginTop = showEl.style.marginTop;
            },
            hidden () {
              mediaViewer.hide();
            },
          });
          this.viewer.show();
        }
      }
    } else {
      el.className = 'hobbit_media show';
    }
  }

  hide() {
    this.el().className = 'hobbit_media';
    if (this.el().children[1]) {
      this.el().children[1].remove();
    }
  }
};

export default new MediaView();
